<section class="app-page-error-state" role="alert" aria-live="assertive">
    <h2 class="app-page-error-state__title">{{ (error.title || '') | translate }}</h2>
    <p class="app-page-error-state__message">{{ error.message | translate }}</p>
    <button
        *ngIf="error.retryable"
        type="button"
        class="app-page-error-state__retry"
        (click)="retry.emit()">
        {{ retryLabel | translate }}
    </button>
</section>
